import * as React from 'react';
import { toGradientStyle } from '../helpers';
import { Span } from './Span';
export const LinearGradient = ({ children, gradient, fallbackColor, ...rest }) => {
    const style = {
        ...toGradientStyle(gradient, 'linear', fallbackColor),
        ...rest.style,
    };
    return (React.createElement(Span, { ...rest, style: style }, children));
};
//# sourceMappingURL=LinearGradient.js.map